import { Collapse, Modal, Tab } from 'bootstrap';
window.bootstrap = { Collapse, Modal, Tab };

import { whenDocumentReady } from '../../../paws/assets/frontend/js/helper/documentready';
import { whenResize } from '../../../paws/assets/frontend/js/helper/resize';
import { wsForm } from '../../../paws/assets/frontend/js/helper/wsform';

whenDocumentReady(initModule);
whenResize(resizeModule);
function initModule() {
    // header height
    SetHeaderHeight();
    wsForm();
    DetectScroll();
    document.body.classList.add('paws-loaded');
    DeepLinkAccordion();
}

function resizeModule() {
    SetHeaderHeight();
}

function DeepLinkAccordion() {
    document.addEventListener('click', function(event) {
        if (event.target.hash) {
            let targetElement = document.querySelector(event.target.hash + '.accordion-item');
            if (targetElement) {
                let btn = targetElement.querySelector('.accordion-button');
                let accordion = targetElement.querySelector('.accordion-collapse');
                btn.classList.remove('collapsed');
                btn.setAttribute('aria-expanded', true);
                accordion.classList.add('show');
            }
        }
    })
}
function DetectScroll() {
    document.addEventListener('scroll', function(e) {
        if (window.scrollY > 0) {
            document.body.classList.add('paws-scrolled');
        }
        else {
            document.body.classList.remove('paws-scrolled');
        }
    })
}

function SetHeaderHeight() {
    let headerHeight = 0;
    let completeHeight = 0;
    const header = document.querySelector('header');
    if (header) {
        headerHeight = header.offsetHeight;
        completeHeight = headerHeight;
    }

    const wpadminbar = document.querySelector('#wpadminbar');
    if (wpadminbar) {
        completeHeight = completeHeight + wpadminbar.offsetHeight;
        document.documentElement.style.setProperty('--paws-adminbar-height', wpadminbar.offsetHeight + 'px');
    }
    else {
        document.documentElement.style.setProperty('--paws-adminbar-height', 0);
    }

    if (headerHeight < 1) {
        setTimeout(function() {SetHeaderHeight()}, 250);
    }

    window.headerHeight = completeHeight;
    document.documentElement.style.setProperty('--paws-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--paws-completeheader-height', completeHeight + 'px');
}